module.exports = {
	model: {
		info: ''
	},

	hooks: {
		updateInfo: function($element, options){
			options = options || {};

			if(options.info){
				this.model.info = options.info;
			} else {
				this.model.info = '';
			}
			this.refresh();
		}
	}
}